import React, { useCallback, useEffect, useState } from "react";
import { Biscuit } from "../../../../utils";
import { Backbone, moment } from "../../../../../vendor";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
/*import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';*/
import { reservationsActions, useSelector } from "inbooma-api";
import "react-big-calendar/lib/css/react-big-calendar.css";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import t from "../../../helpers/t";
import { getContentModifications } from "../../../../App";
import { isViewVisible } from "../../../../utils/ViewSettings";
import { rbac } from "../index";
import { dateFormat, timeFormat } from "../../../../utils/FormatHelper";

const CalendarView = (props) => {
  let language = Biscuit.get("user.lang").replace("-", "_");
  const [initialized, setInitialized] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderEmpty, setOrderEmpty] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [ordersPending, setOrdersPending] = useState(false);
  const [events, setEvents] = useState(null);
  const _orders = useSelector((state) => state.reservations.getReservations);
  let allViews = Object.keys(Views).map((k) => Views[k]);
  moment.locale(language);
  const localizer = momentLocalizer(moment);

  useEffect(() => {
    if (_orders.success === "") {
      return;
    }

    var dataLength = typeof _orders.data.length === "undefined" ? 0 : _orders.data.length;

    if (ordersPending === false && orders.length === dataLength) return;

    if (_orders.success === true) {
      setOrderSuccess(true);
      if (dataLength < 1) {
        setOrderEmpty(true);
      }
      let clone = [...orders];
      clone.push(..._orders.data);
      setOrders(clone);
    } else {
      setInitialized(true);
      console.log("Failed fetching orders!");
    }

    setOrdersPending(false);
  }, [_orders]);

  useEffect(() => {
    if (orders === [] && !ordersPending && !orderEmpty && orderSuccess) {
      return;
    }
    if (orderEmpty) {
      setInitialized(true);
    }
    if (ordersPending) {
      return;
    }
    let _calendarEvents = [];
    if (events !== null) {
      _calendarEvents = [...events];
    }

    orders.map((reservation) => {
      addCalendarEvent(_calendarEvents, reservation, reservation?.order?.user);
    });
    setEvents(_calendarEvents);

    setInitialized(true);
  }, [orders]);

  const submenuItems = [
    {
      name: t("reservations", null, "capital"),
      link: "reservations/reservationsList?type=bookings&initial=true",
      data_inb_val: t("reservations", null, "capital"),
      icon: "fi fi-list-thumbnails",
      isActive: false,
      isAccessible: isViewVisible("reservationsList", "reservations"),
    },
    {
      name: t("orders", null, "capital"),
      link: "reservations/orders",
      data_inb_val: t("orders", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: isViewVisible("orders", "reservations"),
    },
    {
      name: t("calendar", null, "capital"),
      link: "reservations/calendar",
      data_inb_val: t("calendar", null, "capital"),
      icon: "fi fi-calendar",
      isActive: true,
      isAccessible: isViewVisible("calendar", "reservations"),
    },
  ];
  const isHiddenElement = (id) => {
    let cm = getContentModifications();
    if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
      for (let i = 0; i < cm.hidden_elements.length; i++) {
        if (cm.hidden_elements[i] === id) return true;
      }
    }
    return false;
  };

  const [date, setDate] = useState(new Date());
  const fetchData = (begin, end) => {
    props.dispatch(
      reservationsActions.getReservations({
        token: Biscuit.get("token"),
        suffix: "",
        filter: {
          find: "full",
          finder: "NotCancelled",
          end_gte: begin,
          begin_lte: end,
          limit: 9999,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setOrdersPending(true);
  };
  const onNavigate = useCallback((newDate) => setDate(newDate), [setDate]);
  const onShowMore = useCallback((events, date) => {
    setV("day");
  }, []);
  const [v, setV] = useState("month");
  const onRangeChange = useCallback(
    (e) => {
      console.log("onRangeChange", e);
      let start, end, type;
      if (typeof e.length === "undefined") {
        type = "month";
        start = e.start;
        end = e.end;
      } else if (e.length === 7) {
        type = "week";
        start = e[0].date;
        end = e[6].date;
      } else if (e.length === 1) {
        type = "day";
        start = e[0].date;
        end = e[0].date;
      }
      setV(type);
      let begin = moment(start).format("YYYY-MM-DD");
      let ends = moment(end).format("YYYY-MM-DD");
      if (type === "month") {
        fetchData(begin, ends);
      }
    },
    [setV, fetchData],
  );

  const addCalendarEvent = (evs, reservation, user) => {
    let u;
    if (typeof user === "undefined" || user === null) {
      u = "? ";
    } else {
      u = typeof user.first_name === undefined ? "?" : user.first_name + " " + user.last_name;
    }
    let endReserv =
      reservation.end !== null &&
      moment(reservation.end).format("DD.MM.YY") !== moment(reservation.begin).format("DD.MM.YY");
    let timeString = endReserv
      ? moment(reservation.begin).format(dateFormat(language, true)) +
        " - " +
        moment(reservation.end).format(dateFormat(language, true))
      : moment(reservation.begin).format(timeFormat(language)) +
        " - " +
        moment(reservation.end).format(timeFormat(language));
    let set = true;
    if (events !== null) {
      events.map((ev) => {
        if (ev.id === reservation.id) {
          set = false;
        }
      });
    }
    if (set) {
      let res = {
        order_id: reservation.order_id !== null ? reservation.order_id : "",
        id: reservation.id,
        /*start: new Date(moment(reservation.begin).year(),moment(reservation.begin).month(),moment(reservation.begin).day(),moment(reservation.begin).hours(),moment(reservation.begin).minutes(),moment(reservation.begin).seconds()),
                end: new Date(moment(reservation.end).year(),moment(reservation.end).month(),moment(reservation.end).day(),moment(reservation.end).hours(),moment(reservation.end).minutes(),moment(reservation.end).seconds()),*/
        start: new Date(reservation.begin),
        end: new Date(reservation.end),
        title: timeString + " - " + u,
      };
      evs.push(res);
    }
    //if (shouldRender) that.render();
  };

  const initialize = () => {
    if (initialized || ordersPending || orderSuccess) return;
    let range = getMonthDateRange(date.getFullYear(), date.getMonth());
    fetchData(range.start, range.end);
  };

  if (initialized === false) initialize();
  const messages = {
    week: t("week"),
    work_week: t("work_week"),
    day: t("daytime"),
    month: t("month"),
    previous: t("previous"),
    next: t("next"),
    today: t("today"),
    agenda: t("agenda"),
    allDay: t("allDay"),
    yesterday: t("yesterday"),
    tomorrow: t("tomorrow"),

    showMore: (total) => `+${total}  ${t("showMore")}`,
  };
  return (
    <>
      <div id="inb-c-main" className="columns">
        <InboomaSubmenu
          tabs={submenuItems}
          searchbar={false}
          smallOnlyTitle={t("calendar", null, "capital")}
        />
        {/* {initialized ? <div id="calendar"><FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                    }}
                    initialView='dayGridMonth'
                    weekends={true}
                    initialEvents={_calendarEvents}
                    eventContent={renderEventContent}
                    navLinks={true}
                    editable={false}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                   // eventLimit={true}
                    //locale={language === 'de_DE' ? 'de' : 'en'}
                    /></div>:"nothing to render"}*/}
        <div style={{ height: "40px", width: "100%" }}>
          {ordersPending && initialized && (
            <>
              <div style={{ maxHeight: "40px", width: "100%", textAlign: "center" }}>
                <img className="rollingLoader colorize-black" src="assets/img/rolling_loader.svg" />
              </div>
            </>
          )}
        </div>
        <div style={{ padding: "40px", paddingTop: "0px", height: "100%" }}>
          {initialized && events !== null ? (
            <>
              <Calendar
                views={["month", "week", "day"]}
                culture={language}
                messages={messages}
                showMultiDayTimes
                selectable
                localizer={localizer}
                date={date}
                defaultDate={date}
                defaultView={v}
                events={events}
                style={{ height: "100%", width: "100%" }}
                onSelectEvent={(event) =>
                  rbac.hasPermission("edit")
                    ? Backbone.history.navigate("orders/" + event.order_id + "/edit/" + event.id, {
                        trigger: true,
                      })
                    : null
                }
                startAccessor="start"
                endAccessor="end"
                onRangeChange={onRangeChange}
                onNavigate={onNavigate}
                onShowMore={onShowMore}
              />
            </>
          ) : (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img
                    className="rollingLoader colorize-black"
                    src="assets/img/rolling_loader.svg"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CalendarView;

function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  );
}

function getMonthDateRange(year, month) {
  // array is 'year', 'month', 'day', etc
  let startDate = moment([year, month]);

  // Clone the value before .endOf()
  let endDate = moment(startDate).endOf("month").format("YYYY-MM-DD");
  startDate = startDate.format("YYYY-MM-DD");
  // just for demonstration:
  /* console.log(startDate.toDate());
    console.log(endDate.toDate());*/

  // make sure to call toDate() for plain JavaScript date type
  return { start: startDate, end: endDate };
}
